import React from "react";
import { spacings } from "@/assets/themes";
import useBreakpoints from "@/modules/hooks/use-breakpoints";
import Block from "../../block";
import Button from "../../button";
import Icon from "../../icon";
import { BUTTON } from "@/components/styles/variants/button";
import { Body16, H1, H2 } from "../../text";

const Header = ({ children, onBack, onClose, title, subtitle, navBarContent, className }) => {
  const breakpoints = useBreakpoints();

  return (
    <Block className={className} display="flex" flexDirection="column">
      <Block
        alignItems="center"
        display="flex"
        justifyContent="space-between"
        paddingTop={onClose || onBack ? spacings.s : spacings.sm}
        paddingX={spacings.s}
      >
        {onBack && (
          <Button.Small
            kind={BUTTON.KIND.MINIMAL}
            onClick={onBack}
            shape={BUTTON.SHAPE.CIRCLE}
            style={{ marginRight: "auto" }}
            type="button"
          >
            <Icon.Large name="arrow-left" />
          </Button.Small>
        )}
        {navBarContent && navBarContent()}
        {onClose && (
          <Button.Small
            kind={BUTTON.KIND.MINIMAL}
            onClick={onClose}
            shape={BUTTON.SHAPE.CIRCLE}
            style={{ marginLeft: "auto" }}
            type="button"
          >
            <Icon.Large name="times" />
          </Button.Small>
        )}
      </Block>
      {(children || title || subtitle) && (
        <Block marginBottom={spacings.sm} marginLeft={spacings.m} marginRight={spacings.m}>
          {children || (
            <>
              {breakpoints.get({ xs: <H2>{title}</H2>, sm: <H1>{title}</H1> })}
              {subtitle && <Body16>{subtitle}</Body16>}
            </>
          )}
        </Block>
      )}
    </Block>
  );
};

export default Header;
